import React from 'react';
import './SummaryCard.css';

export interface SummaryCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  trend?: {
    value: number;
    isPositive: boolean;
    period: string;
  };
  onClick?: () => void;
  variant?: 'default' | 'highlight' | 'success' | 'warning';
  size?: 'small' | 'medium' | 'large';
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  onClick,
  variant = 'default',
  size = 'medium'
}) => {
  const formatTrendValue = (trendValue: number) => {
    const sign = trendValue > 0 ? '+' : '';
    return `${sign}${trendValue}%`;
  };

  return (
    <div 
      className={`summary-card summary-card--${variant} summary-card--${size} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {icon && <span className="card-icon">{icon}</span>}
      </div>
      
      <div className="card-content">
        <div className="card-value">{value}</div>
        
        {subtitle && (
          <p className="card-subtitle">{subtitle}</p>
        )}
        
        {trend && (
          <div className={`card-trend ${trend.isPositive ? 'positive' : 'negative'}`}>
            <span className="trend-value">
              {formatTrendValue(trend.value)}
            </span>
            <span className="trend-period">
              {trend.period}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SummaryCard; 